import script from "./Presence.vue?vue&type=script&setup=true&lang=js"
export * from "./Presence.vue?vue&type=script&setup=true&lang=js"

import "./Presence.vue?vue&type=style&index=0&id=2f2d058f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f2d058f"]])

export default __exports__